/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import queryString from 'query-string';
import {
	ASSETS_APP_OBJECT_ROUTE_PREFIX,
	ASSETS_APP_ROUTE_PREFIX,
} from '@jira/servicedesk__insight-common-utils-insight-urls/src/getLandingPageUrl.tsx';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';

export const getRedirectionUrl = (
	match: RouteContext['match'],
	query: RouteContext['query'],
): string => {
	const pattern = /\/jira\/servicedesk\/(assets|insight)/;

	// We are intentionally using a new regex for being extra safe and not to disturb original regex used for majority of the app routes
	const objectPathPattern = /\/jira\/servicedesk\/insight\/assets/;

	let redirectionUrl: string;

	if (match.url.match(objectPathPattern)) {
		redirectionUrl = match.url.replace(objectPathPattern, ASSETS_APP_OBJECT_ROUTE_PREFIX);
	} else {
		redirectionUrl = match.url.replace(pattern, ASSETS_APP_ROUTE_PREFIX);
	}

	if (Object.keys(query).length > 0) {
		redirectionUrl += `?${queryString.stringify(query)}`;
	}

	return redirectionUrl;
};

export const AssetsAppRedirect = ({ match, query }: RouteContext): React.JSX.Element => {
	const redirectionUrl = getRedirectionUrl(match, query);

	const analyticsAttributes = {
		matchedRoute: match.path,
	};

	return (
		<ContextualAnalyticsData sourceType={SCREEN} sourceName="assetsAppRedirect">
			<Redirect to={redirectionUrl} push={false} />
			<FireScreenAnalytics attributes={analyticsAttributes} />
		</ContextualAnalyticsData>
	);
};
